export const kilogramsToOuncesConversionRate = 35.274;
export const centimetersToInchesConversionRate = 0.393701;
export const celsiusToFahrenheitConversionRate = 1.8;

export const HEIGHT_VITAL_SERVICE_NAME = 'HeightLength';
export const WEIGHT_VITAL_SERVICE_NAME = 'Weight';
export const HEART_RATE_VITAL_SERVICE_NAME = 'HeartRate';
export const BLOOD_PRESSURE_VITAL_SERVICE_NAME = 'BloodPressure';
export const BLOOD_TYPE_VITAL_SERVICE_NAME = 'Blood Type';
export const TEMPERATURE_VITAL_SERVICE_NAME = 'Temperature';
export const RESPIRATORY_RATE_VITAL_SERVICE_NAME = 'RespiratoryRate';
export const BMI_VITAL_SERVICE_NAME = 'BMI';
export const HEAD_CIRCUMFERENCE_VITAL_SERVICE_NAME = 'HeadCircumference';

export const CHART_VITAL_NAMES = [
  WEIGHT_VITAL_SERVICE_NAME,
  BMI_VITAL_SERVICE_NAME,
  BLOOD_PRESSURE_VITAL_SERVICE_NAME
];

export const TABLE_VITAL_NAMES = [
  HEIGHT_VITAL_SERVICE_NAME,
  HEART_RATE_VITAL_SERVICE_NAME,
  TEMPERATURE_VITAL_SERVICE_NAME,
  RESPIRATORY_RATE_VITAL_SERVICE_NAME,
  HEAD_CIRCUMFERENCE_VITAL_SERVICE_NAME
];

export const showStatusInTable = [
  HEART_RATE_VITAL_SERVICE_NAME,
  TEMPERATURE_VITAL_SERVICE_NAME,
  RESPIRATORY_RATE_VITAL_SERVICE_NAME,
  HEAD_CIRCUMFERENCE_VITAL_SERVICE_NAME,
  BMI_VITAL_SERVICE_NAME,
  BLOOD_PRESSURE_VITAL_SERVICE_NAME
];

export const LOW_INTERPRETATION = 'low';
export const NORMAL_INTERPRETATION = 'normal';
export const HIGH_INTERPRETATION = 'high';
export const BMI_UNDERWEIGHT = 'underweight';
export const BMI_OVERWEIGHT = 'overweight';
export const BMI_OBESE = 'obese';
export const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const SYSTOLIC = 'Systolic Blood Pressure';
export const DIASTOLIC = 'Diastolic Blood Pressure';
export const LEGEND_NORMAL = 'NORMAL';
export const LEGEND_HIGHLOW = 'HIGH/LOW';
